import UnprocessedProjectProvider from "./provider";
import UnprocessedView from "./view";

export default function Unprocessed({ project, statements, metadata }) {
  return (
    <UnprocessedProjectProvider
      project={project}
      statements={statements}
      metadata={metadata}
    >
      <UnprocessedView />
    </UnprocessedProjectProvider>
  );
}
